import clsx from 'clsx';
import { AppLink } from './AppLink';
import { Button } from './Button';

interface Props {
  /** The file's path, or undefined when the file has not been received yet. */
  href?: string;
  /** What the file is, e.g. "Syllabus PDF". The arrow and "soon" are added here. */
  label: string;
  as?: 'link' | 'button';
  /** Accessible name when several links share the same visible text. */
  ariaLabel?: string;
  className?: string;
}

// A download that is honest about itself: a real link when the file exists,
// plain muted text saying it is coming when it does not.
export function FileLink({ href, label, as = 'link', ariaLabel, className }: Props) {
  if (as === 'button') {
    return href ? (
      <Button href={href} className={className}>{`${label} ↓`}</Button>
    ) : (
      <span
        className={clsx(
          'inline-flex min-h-12 items-center rounded-control border border-rule-strong bg-sky-50 px-[22px] font-semibold text-muted',
          className,
        )}
      >
        {label} · soon
      </span>
    );
  }
  return href ? (
    <AppLink href={href} aria-label={ariaLabel} className={clsx('tap font-semibold underline underline-offset-[3px]', className)}>
      {`${label} ↓`}
    </AppLink>
  ) : (
    <span className={clsx('font-semibold text-muted', className)}>{label} · soon</span>
  );
}
